/* @flow */
import React from 'react';
import { IndexRoute, Route } from 'react-router';

import TransactionSettingsView from 'payments/components/TransactionSettingsView.jsx';
import ChatSettingsView from './components/ChatSettingsView.jsx';
import WidgetSettingsView from './components/WidgetSettingsView.jsx';
import PrintSettingsView from './components/PrintSettingsView.jsx';
import SettingsViewRouteHandler from './routeHandlers/SettingsViewRouteHandler.jsx';
import UserSettingsView from './components/UserSettingsView.jsx';
import PrivacySettingsView from './components/PrivacySettingsView.jsx';
import NotificationSettingsContainer from './containers/NotificationSettingsContainer.jsx';
import ArchivedClassesView from 'settings/components/ArchivedClassesView.jsx';
import UserProfileView from 'settings/components/UserProfileView.jsx';
import AccountSettingsView from 'settings/components/AccountSettingsView.jsx';
import chainOnEnter from 'components/lib/chainOnEnter';
import RequireOwner from 'components/mixins/RequireOwner';

const requireOwner = chainOnEnter([RequireOwner]);

export default (
  <Route
    path="/settings(/)"
    component={SettingsViewRouteHandler}
    onEnter={SettingsViewRouteHandler.onEnter}>
    <Route
      path="/settings/chat"
      component={ChatSettingsView}
      onEnter={requireOwner}
    />
    <Route
      path="/settings/notifications"
      component={NotificationSettingsContainer}
    />
    <Route
      path="/settings/widget"
      component={WidgetSettingsView}
      onEnter={requireOwner}
    />
    <Route
      path="/settings/export"
      component={PrintSettingsView}
      onEnter={requireOwner}
    />
    <Route
      path="/settings/transactions"
      component={TransactionSettingsView}
      // $FlowIssue - those statics are hoisted by connect() HOC.
      onEnter={TransactionSettingsView.onEnter}
    />
    <Route
      path="/settings/privacy"
      component={PrivacySettingsView}
    />
    <Route
      path="/settings/archived"
      component={ArchivedClassesView}
    />
    <Route
      path="/settings/profile"
      component={UserProfileView}
      onEnter={UserProfileView.onEnter}
    />
    <Route
      path="/settings/account"
      component={AccountSettingsView}
      onEnter={AccountSettingsView.onEnter}
    />
    <IndexRoute component={UserSettingsView} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/settings/routes.js